import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SessaoContatoInformativoModel} from '../../../shared/model/sessao/sessao-contato-informativo.model';
import {DatePipe} from '@angular/common';
import {CelularMaskPipe} from '../../../shared/pipe/celular-mask.pipe';
import {ProgressBarDataComponent} from '../../../shared/components/progress-bar-data/progress-bar-data.component';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import { MethodsUtils } from '../../../shared/util/methods.utils';

@Component({
  selector: 'app-card-fila-contato-sessao',
  standalone: true,
  imports: [
    DatePipe,
    CelularMaskPipe,
    ProgressBarDataComponent,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './card-fila-contato-sessao.component.html',
  styleUrl: './card-fila-contato-sessao.component.css'
})
export class CardFilaContatoSessaoComponent {

  @Input() fila?: SessaoContatoInformativoModel;
  @Output() cardSelecionado = new EventEmitter<SessaoContatoInformativoModel>();

  selecionarCard(){
    this.cardSelecionado.emit(this.fila);
  }

  converterParaHoraMinuto(input: string | number | null | undefined): string {
    if (input === null || input === undefined) {
      return '00h:00m';
    }
    if (typeof input === 'number') {
      const totalMinutes = Math.floor(input / 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours.toString().padStart(2, '0')}h:${minutes.toString().padStart(2, '0')}m`;
    }
    if (typeof input === 'string') {
      const regex = /(?:(\d+)d)?\s*(?:(\d+)h)?:?(?:(\d+)m)?:?(?:(\d+)s)?/;
      const match = input.match(regex);

      if (!match) {
        return '00h:00m';
      }

      const days = parseInt(match[1] || '0', 10);
      const hours = parseInt(match[2] || '0', 10);
      const minutes = parseInt(match[3] || '0', 10);
      const totalHours = days * 24 + hours;
      return `${totalHours.toString().padStart(2, '0')}h:${minutes.toString().padStart(2, '0')}m`;
    }
    return '00h:00m';
  }

  montarTextoTags(): string {
    let texto = '';
    this.fila?.tagsSessao.forEach(tag => {
      texto += `${tag}, `;
    });
    return texto
  }

  verificarFotoContato(contatoSelecionado: SessaoContatoInformativoModel | undefined): string {
    if(contatoSelecionado){
      return MethodsUtils.informacoesPorStatusContato(contatoSelecionado.statusContato, true);
    }else{
      return "assets/icones/box-happy.png"
    }
  }

  toolTipFotoContato(contatoSelecionado: SessaoContatoInformativoModel | undefined): string {
    if(contatoSelecionado){
      return MethodsUtils.informacoesPorStatusContato(contatoSelecionado.statusContato, false);
    }else{
      return ""
    }
  }

}
